export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHUlEQVR42mNgYGD4TyFm+F9OJh41YNQA6hpACQYA3I0AZHABuqwAAAAASUVORK5CYII="